import { Highlight, themes } from "prism-react-renderer";
import { Card, CardBody, Col } from "reactstrap";
import { cssData } from "../../../../Data/Editor/Editor";
import CardHeaderCommon from "../../../../Utils/CommonComponents/CardHeaderCommon";
import { CSSModeHeading } from "../../../../Utils/Constants";

const CssMode = () => {
  return (
    <Col xl="6">
      <Card>
        <CardHeaderCommon title={CSSModeHeading} />
        <CardBody>
          <Highlight theme={themes.vsDark} code={cssData} language="css">
            {({ style, tokens, getLineProps, getTokenProps }) => (
              <pre style={style}>
                {tokens.map((line, i) => (
                  <div key={i} {...getLineProps({ line })}>
                    {line.map((token, key) => (
                      <span key={key} {...getTokenProps({ token })} />
                    ))}
                  </div>
                ))}
              </pre>
            )}
          </Highlight>
        </CardBody>
      </Card>
    </Col>
  );
};

export default CssMode;
